import React from "react";
import "./App.css";
import Store from "../store";
import { BrowserRouter as Router } from "react-router-dom";
import Routes from "./Routes";
import { MuiThemeProvider } from "@material-ui/core";
import muiTheme from "./Theme";
// PM5 T0 — MUI v5+ provider, nested inside the v4 one for the coexistence era.
// The two libraries use entirely separate theme contexts (@material-ui/styles
// vs @mui/private-theming), so neither shadows the other; both themes are fed
// from src/theme/tokens.ts. Removed with the v4 provider at T6.
import { ThemeProvider as MuiV5ThemeProvider } from "@mui/material/styles";
import themeV5 from "../theme/themeV5";
import { ToastProvider } from "react-toast-notifications";
import SearchContainer from "./Search/SearchContainer";
import ShareContainer from "./Share/ShareContainer";
import TryBuyContainer from "./Onboarding/TryBuyContainer";
import { ScrollToTopOnRouteChange } from "./common/ScrollToTopOnRouteChange";
import { captureAttribution } from "../utils/attribution";

export default function App() {
  React.useEffect(() => {
    captureAttribution(window.location.search);
  }, []);

  return (
    <MuiThemeProvider theme={muiTheme}>
      <MuiV5ThemeProvider theme={themeV5}>
        <ToastProvider autoDismiss={true} placement="top-right">
          <ShareContainer>
            <Router>
              <ScrollToTopOnRouteChange />
              <Store>
                <SearchContainer>
                  <TryBuyContainer>
                    <Routes />
                  </TryBuyContainer>
                </SearchContainer>
              </Store>
            </Router>
          </ShareContainer>
        </ToastProvider>
      </MuiV5ThemeProvider>
    </MuiThemeProvider>
  );
}
